module.exports = __webpack_public_path__ + "images/d902363.png";